import {serviceAPI} from './service.api';

export const api = serviceAPI;
export * from './token';
export * from './service';